import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  Field,
  reduxForm,
  formValueSelector,
  change,
  getFormValues,
} from "redux-form";
import { TextField, Select } from "redux-form-material-ui";
import { required } from "../../common/Validations";
import {
  Button,
  Box,
  Chip,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Grid,
  InputLabel,
  MenuItem,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { withTheme } from "@material-ui/core/styles";
import { actionMovementsLoyalty } from "../../actions/UserActions";
import Util, { SUCCESS, ERROR } from "../../common/Util";
import ImageSelector from "../../components/ImageSelector/ImageSelector";

class MovementsLoyalty extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { points: null, movements: [], page: 0, rowPerPage: 10 };
    this.onClose = this.onClose.bind(this);
    this.onMovementsLoyaltySuccess = this.onMovementsLoyaltySuccess.bind(this);
    this.onMovementsLoyaltyError = this.onMovementsLoyaltyError.bind(this);
    this.renderTableHeader = this.renderTableHeader.bind(this);
    this.renderTableBody = this.renderTableBody.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user && nextProps.user != this.props.user) {
      this.props.actionMovementsLoyalty(
        nextProps.user,
        this.onMovementsLoyaltySuccess,
        this.onMovementsLoyaltyError
      );
    }
  }

  onMovementsLoyaltySuccess(response) {
    const { data } = response;
    this.setState(
      { points: data.points, movements: data.movements },
      this.onChangePage
    );
  }

  onMovementsLoyaltyError(error) {
    console.log("ERROR", error);
    Util.showNoty(ERROR, "Ocurrió un error al listar los últimos movimientos.");
  }

  onClose(SUCCESS) {
    this.setState({ points: null, movements: [] });
    this.props.onClose(SUCCESS);
  }

  onChangePage(dta, newPage = 0) {
    let movements = this.state.movements;
    const from = newPage * this.state.rowPerPage;
    const to = from + this.state.rowPerPage;
    movements = movements.sort((a, b) => {
      return Util.timestampToMoment(a.mo_date).isBefore(
        Util.timestampToMoment(b.mo_date)
      )
        ? 1
        : -1;
    });
    movements = movements.slice(from, to);
    console.log("pageMovements", from, to, movements);
    this.setState({ page: newPage, pageMovements: movements });
  }

  onChangeRowsPerPage(evt) {
    this.setState(
      {
        rowPerPage: evt.target.value,
      },
      this.onChangePage
    );
  }

  renderTableHeader() {
    const { theme } = this.props;
    const headers = [
      { id: "mo_description", label: "Descripción" },
      { id: "mo_date", label: "Fecha" },
      { id: "mo_points", label: "Puntos" },
    ];

    return (
      <TableRow>
        {headers.map((headCell, i) => {
          return <TableCell> {headCell.label}</TableCell>;
        })}
      </TableRow>
    );
  }

  renderTableBody() {
    const { theme } = this.props;
    let movements = this.state.pageMovements;
    if (!movements || movements.length == 0) {
      return <Box style={theme.table.empty}>No se encontraron registros</Box>;
    }
    return movements.map((item, index) => {
      let date = Util.timestampToMoment(item.mo_date);
      return (
        <TableRow
          style={index % 2 == 0 ? theme.table.row : theme.table.rowColor}
        >
          <TableCell
            style={{ color: item.mo_movtype !== "s" ? "red" : "green" }}
          >
            {item.mo_description || `Canjeaste por ${item.pr_name}`}
          </TableCell>
          <TableCell>{Util.formatDateToShow(date)}</TableCell>
          <TableCell>{item.mo_movtype !== "s" ? "-" : "+"}{item.mo_points}</TableCell>
        </TableRow>
      );
    });
  }

  render() {
    const { theme, open, user, handleSubmit } = this.props;
    return (
      <Dialog open={open}>
        <DialogTitle>
          <Typography variant="h1" color="primary">
            Últimos movimientos de {user && user.proName}{" "}
            {user && user.proLastName}
          </Typography>
        </DialogTitle>
        <DialogContent style={{ minWidth: 500 }}>
          {this.state.points == null ? (
            <Box style={theme.loading}>
              <CircularProgress style={{ alignSelf: "center" }} />
            </Box>
          ) : (
            [
              <Typography variant="h2" color="primary" align="right">
                Tus puntos: {this.state.points}
              </Typography>,
              <Table stickyHeader>
                <TableHead>{this.renderTableHeader()}</TableHead>
                <TableBody>{this.renderTableBody()}</TableBody>
              </Table>,
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 100]}
                component="div"
                count={this.state.movements.length}
                rowsPerPage={this.state.rowPerPage}
                page={this.state.page}
                onChangePage={this.onChangePage}
                onChangeRowsPerPage={this.onChangeRowsPerPage}
              />,
            ]
          )}
        </DialogContent>
        <DialogActions>
          <Tooltip title="Cerrar">
            <Button
              variant="contained"
              color="secondary"
              onClick={this.onClose}
            >
              Cerrar
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    );
  }
}

// function mapStateToProps(store) {
//   return {

//   };
// }

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionMovementsLoyalty,
    },
    dispatch
  );
}

export default withTheme(connect(null, mapDispatchToProps)(MovementsLoyalty));



// WEBPACK FOOTER //
// ./src/screens/users/MovementsLoyalty.js